/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

import { ISOs } from 'utils/form/constants';

export interface ICountry {
  id: string;
  value: ISOs;
}

export const options: ICountry[] = [
  { id: 'antarctica', value: ISOs.ATA },
  { id: 'austria', value: ISOs.AUT },
  { id: 'canada', value: ISOs.CAN },
  { id: 'switzerland', value: ISOs.CHE },
  { id: 'czechRepublic', value: ISOs.CZE },
  { id: 'germany', value: ISOs.DEU },
  { id: 'spain', value: ISOs.ESP },
  { id: 'france', value: ISOs.FRA },
  { id: 'unitedKingdom', value: ISOs.GBR },
  { id: 'indonesia', value: ISOs.IDN },
  { id: 'japan', value: ISOs.JPN },
  { id: 'southKorea', value: ISOs.KOR },
  { id: 'malaysia', value: ISOs.MYS },
  { id: 'netherlands', value: ISOs.NLD },
  { id: 'newZealand', value: ISOs.NZL },
  { id: 'poland', value: ISOs.POL },
  { id: 'portugal', value: ISOs.PRT },
  { id: 'romania', value: ISOs.ROU },
  { id: 'singapore', value: ISOs.SGP },
  { id: 'thailand', value: ISOs.THA },
  { id: 'taiwan', value: ISOs.TWN },
  { id: 'unitedStates', value: ISOs.USA },
  { id: 'southAfrica', value: ISOs.ZAF },
];
